module.exports = __webpack_public_path__ + "static/case-slide-6-9e38488893211239afe30397784dfc51.jpg";